@if (isNotCarbonCopy) {
  <app-input-phone-number
    #input
    class="ag-input-field-input ag-text-field-input"
    label=""
    [placeholder]="placeholder"
    [disabled]="disabled"
    [validationError]="validationError"
    [usedInsideGrid]="true"
    [(ngModel)]="value"
    (ngModelChange)="onChangeValue($event)"
    (focusin)="onFocus()"
    (blured)="onBlur()"
  />
}

